import React from "react";
import Error from "../../components/Navbar/ui/Error";
import Loading from "../../components/Navbar/ui/Loading";
import { useGetTeamMembersQuery } from "../../features/teamMembers/teamMembersApi";
import TeamMember from "./TeamMember";

export default function TeamMembers() {
  const {
    data: teamMembers,
    isLoading,
    isError,
    error,
  } = useGetTeamMembersQuery() || {};

  // Decided what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error header="TeamMebers Error" message={error?.message} />;
  } else if (!isLoading && !isError && teamMembers?.length === 0) {
    content = <Error header="No Team Member found" message="Warning!!!" />;
  } else if (!isLoading && !isError && teamMembers?.length > 0) {
    content = teamMembers.map((teamMember) => (
      <TeamMember key={teamMember?.id} teamMember={teamMember} />
    ));
  }
  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">{content} </div>
    </div>
  );
}
